module.exports = __webpack_public_path__ + "1c961455cdd748b6b08722d7b445256a.svg";